/* MOD MATIZES 2026-07-29: prefetch de fotos de variante en tarjetas de coleccion.
   Al pasar el cursor por la tarjeta (desktop) o tocar la zona de swatches (movil),
   precarga las imagenes de TODOS los colores de esa tarjeta al ancho exacto que la
   tarjeta usa, para que el cambio de color sea instantaneo (estilo on.com).
   Solo gasta datos en tarjetas con las que la clienta interactua; respeta Save-Data.
   Cargado desde layout/theme.liquid. Re-aplicar referencia tras actualizar Shrine. */
(function () {
  'use strict';
  if (navigator.connection && navigator.connection.saveData) return;
  var done = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function cardWidth(card) {
    var img = card.querySelector('.card__media img');
    var src = (img && (img.currentSrc || img.src)) || '';
    var m = src.match(/[?&]width=(\d+)/);
    return m ? m[1] : '533';
  }

  function prefetchCard(card) {
    if (!card) return;
    if (done) {
      if (done.has(card)) return;
      done.add(card);
    }
    var w = cardWidth(card);
    var chips = card.querySelectorAll('.color-swatch__image img');
    for (var i = 0; i < chips.length; i++) {
      var src = chips[i].currentSrc || chips[i].src || '';
      var base = src.split('?')[0];
      if (!base) continue;
      var pre = new Image();
      pre.decoding = 'async';
      pre.src = base + '?width=' + w;
    }
  }

  document.addEventListener(
    'mouseover',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var card = t.closest('.card-wrapper');
      if (card) prefetchCard(card);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchstart',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('.card__swatches-container')) return;
      prefetchCard(t.closest('.card-wrapper'));
    },
    { passive: true, capture: true }
  );
})();
